import React from "react"
import { withTranslation } from "gatsby-plugin-react-i18next"
import styled from "styled-components"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import breakpoints from "../../styles/breakpoints"

const Sticker = styled.div`
  z-index: 1;
  position: absolute;
  top: ${(props) => (props.cart ? "22px" : "12px")};
  right: ${(props) => (props.cart ? "-4px" : "12px")};
  ${fonts.americana};
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: center;
  background: transparent;
  height: 20px;
  width: 63px;

  p {
    width: 100%;
    height: 100%;
    background: #B8B889;
    color: ${colors.white};
    padding: 5px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: ${breakpoints.xl}) {
    top: ${(props) => (props.cart ? "22px" : "22px")};
    right: ${(props) => (props.cart ? "-4px" : "22px")};
    font-size: ${(props) => (props.cart ? "12px" : "12px")};
    line-height: ${(props) => (props.cart ? "16px" : "16px")};
    height: ${(props) => (props.cart ? "24px" : "32px")};
    width: ${(props) => (props.cart ? "80px" : "100px")};
  }
`

const DiscountSticker = ({ children, t, cart }) => {
  return (
    <Sticker cart={cart}>
      <p>-{children}%</p>
    </Sticker>
  )
}

export default withTranslation()(DiscountSticker)
